module.exports = __webpack_public_path__ + "static/media/process-partner-1.8c447df8.png";